import { all, takeEvery } from 'redux-saga/effects';
import { ACTIONS } from '../types';
import { sendNewMessageChatSaga } from './sendNewMessageChatSaga';

export function* chatSaga() {
  yield all([takeEvery(ACTIONS.SEND_NEW_MESSAGE, sendNewMessageChatSaga)]);
}
